<template>
  <div class="toast">
    <div class="msg">
      <img src="@/assets/img/order/ic_notice.svg" />
      <span>
        픽업시간이 지났거나 임박하였습니다.<br />변경된 시간을 다시 확인해
        주세요!
      </span>
    </div>
    <div class="btn" @click="$emit('close')">확인</div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.toast {
  box-sizing: border-box;
  padding: 12px 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  background-color: var(--gray-700);
  color: var(--white);
  display: flex;
  align-items: center;
  gap: 32px;

  border-radius: 12px;
}

.msg {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn {
  box-sizing: border-box;
  padding: 1px 8px;
  border-radius: 6px;
  border: 1px solid var(--white);
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  cursor: pointer;
}
@media all and (min-width: 1024px) {
  br {
    display: none;
  }
  .toast {
    min-width: 600px;
  }
}
@media all and (max-width: 1023px) {
  .toast {
    gap: 18px;
    width: 370px;
  }
}
</style>
<style src="@/assets/css/newGlobal.css" scoped></style>
